import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { PersonStammMasterDetailEntryMeta } from '../../../../../core/personstamm-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { TranslatePipe } from '@ngx-translate/core';
import { KompaktStammpersonComponent } from '../../../../../shared/kompaktdarstellung/stammperson/kompakt-stammperson.component';

@Component({
  selector: 'cap-navigation-check-modal',
  templateUrl: './navigation-check-modal.component.html',
  styleUrls: ['./navigation-check-modal.component.scss'],
  imports: [TranslatePipe, NgbTooltip, KompaktStammpersonComponent]
})
export class NavigationCheckModalComponent implements AfterViewInit {
  @Input()
  personStammMaster: PersonStammMasterDetailEntryMeta;

  @ViewChild('yesBtn', { static: false })
  submitButton: ElementRef;

  constructor(public activeModal: NgbActiveModal) {
    keysToTranslate(['egbpid.gehoertZuStammperson', 'egbpid.stammpersonAnzeigen', 'egbpid.navigationTitel']);
  }

  ngAfterViewInit() {
    this.submitButton.nativeElement.focus();
  }
}
